var api = "https://api.qingcigame.com";
var activeKey = '7974977f085eb505dbf63755c2328a13';
const config = {
  account: "",
  channel: "",
  id: "",
  platform: "",
  area: "",
  game_id:60,
  role_id: "",
  page_id: 11,
  roleName:''
};
let bindParams = {};
let timer = null;
let wait = 60;

var initialSlide = 0; //设置默认索引为0
var shareText = '';
shareText = [
  '珍綺華筵，蝶舞翩躚。首款Clamp雜誌款小小櫻限時發售中，點擊鏈接查看',
  '與我一起前往寶石之境，攜手夢幻小小櫻開啟神秘國度之旅。點擊鏈接前往',
  '《庫洛魔法使 透明牌篇》滿月慶典現已開啟！首款夢幻小小櫻限時發售中，快來參與慶典吧！'
][Math.floor(Math.random() * 3)];

var requestInterface =  {};
var routerParams = {};
var awardNum = 0; // 可以领取的奖励数量
var gameNum = 0; // 游戏次数
var isBindRole = false;

var obj = {
  index: function() {
      this.preloading(); // 预加载
      this.onAdapt();
      this.indexBind(); // 首页按钮
      routerParams = analysisParams(window.location.href);
      if (routerParams.helper_id) {
        requestInterface.share({helper_id: routerParams.helper_id});
      }
      if(routerParams.role_id) {
        requestInterface.accountLogin(
          {role_id: routerParams.role_id, game_id:60}, function(response) {
            localStorage.setItem('access_token', response.data.access_token);
            $('.popup').fadeOut();
            obj.onInit();
          });
          return
      }
      this.onInit();
  },
  onAdapt: function() {
    //小屏自适应
    const width = $(window).width();
    const height = $(window).height();
    const aspectRatio = Number((width / height).toFixed(3));
    console.log('aspectRatio', aspectRatio);
    if (aspectRatio >= 0.63) {
      $('body').addClass('adapt-2');
    } else if (aspectRatio >= 0.585) {
      $('body').addClass('adapt-1');
    }
  },
  preloading: function() {
    var queue = new createjs.LoadQueue();
    queue.on("progress", function(e) {

      //加载中的进度
      if (e.progress * 100 >= 10) {
          $(".preloading #percent").html(parseInt(e.progress * 100));
      };
    }, this);
    queue.on("complete", function(e) {
      //加载完成执行操作
      $('.content').addClass('index-show');
      this.indexSwiper();
      $('.preloading').fadeOut();
      setTimeout(function() {
        $('.preloading').remove();
      }, 1000)
    }, this);
    queue.loadManifest([
      '/card-pool/images/mobile/preloading_bg-ec6d23ece4.jpg',
      '/card-pool/images/mobile/index_bg-65b689794d.jpg',
      '/card-pool/images/mobile/slogo-de3831759f.png',
      '/card-pool/images/mobile/header_bg-a49d193855.png'
    ]);
  },
  indexBind: function() {
    // 登陆相关绑定事件
    obj.loginEventBind();
    // 通用绑定事件
    $('.close_bg').on('click', function() {
      $('.popup').fadeOut();
    });

    $('.cg_popup .close_btn').on('click', function() {
      $('.cg_popup').fadeOut();
    });

    $('.share_list .change_btn').on('click', function() {
      if ($('.share_list').hasClass('on')) {
        $('.share_list').removeClass('on');
      } else {
        $('.share_list').addClass('on');
      }
    });

    // $('.wechat_btn').on('click', function() {
    //   $('.wechat_popup').fadeIn();
    // });
    $('.wechat_popup .confirm_btn').on('click', function() {
      $('.wechat_popup').fadeOut();
    });

    $('.award_list_btn').on('click', function() {
      $('.award_list_popup').fadeIn();
      requestInterface.countNum('奖池列表');
    });
    $('.prize_btn').on('click', function() {
      if (!config.account) {
        layer.msg("請先登入");
        return false;
      }
      $('.my_prize_popup').fadeIn();
      requestInterface.countNum('我的奖品');
    });
    $('.share_btn').on('click', function() {
      if (!config.account) {
        layer.msg("請先登入");
        return false;
      }
      $('.share_popup').fadeIn();
      requestInterface.countNum('分享按钮');
    });
    $('.download_btn').on('click', function() {
      // 判断是安卓还是苹果
      if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.snell.sakura.ggp.tw'
      } else if (navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('iPad') > -1) {
        window.location.href ='https://apps.apple.com/app/id6462015934'
      }
    });
    $('.rule_btn').on('click', function() {
      $('.rule_popup').fadeIn();
      requestInterface.countNum('规则按钮');
    });
    $('.rule_popup .confirm_btn').on('click', function() {
      $('.rule_popup').fadeOut();
    });

    $('.cg_btn').on('click', function() {
      const idx = $(this).data('idx');
      $('.cg_box').attr('class', `cg_box popup_box cg_box_${idx}`);
      $('.cg_image').hide();
      $(`.cg_${idx}`).show();
      $('.cg_popup').fadeIn();
      requestInterface.countNum('查看CG图');
    });

    $('.award_list_box .confirm_btn').on('click', function() {
      $('.award_list_popup').fadeOut();
    });
    $('.my_prize .receive_btn').on('click', function() {
      if (awardNum === 0) {
        layer.msg("沒有能領取的獎品，快去祈願吧");
        return false;
      }
      // 打开弹窗
      if (isBindRole) { // 已经绑定角色，提示奖励领取到哪个角色
        $('.reward_popup').fadeIn();
      } else { // 未绑定的让玩家绑定角色
        obj.serverInfo(config.account);
      }
      requestInterface.countNum('一键领取');
    });
    $('.lottery_btn').on('click', function() {
      if (!config.account) {
        layer.msg("請先登入");
        return false;
      }
      $('.prevent-wrap').show();
      requestInterface.lottery({}, function(response) {
        if (response.code == 200) {
          const { prize_id, title, is_prize } = response.data;
          if (is_prize == 0) {
            $('.un_award_popup').fadeIn();
          } else {
            $('.prize_popup .prop').attr('class', `prop prop_${prize_id}`);
            $('.prize_popup .prop_name').text(title);
            $('.prize_popup').fadeIn();
          }
        }
      });
      requestInterface.countNum('祈愿按钮');
    });

    $('.prize_popup .confirm_btn, .un_award_popup .confirm_btn').on('click', function() {
      $('.prize_popup, .un_award_popup').fadeOut();
      obj.onInit();
    });

    // 确认领奖
    $('.bind_confirm_popup .confirm_btn, .reward_popup .confirm_btn').on('click', function() {
      requestInterface.reward({...bindParams}, function() {
        $('.my_prize_popup').fadeOut();
        $('.reward_popup').fadeOut();
        $('.bind_confirm_popup').fadeOut();
        layer.msg("領取成功", { time: 2000 });
        obj.onInit();
      });
    });
    // 确认绑定-返回
    $('.bind_confirm_popup .return_btn').on('click', function() {
      bindParams = {};
      $('.bind_confirm_popup').fadeOut();
      obj.serverInfo(config.account);
    });
    $('.reward_popup .close_btn').on('click', function() {
      $('.reward_popup').fadeOut();
    });
    $('.close_bind').on('click', function() {
      $('.bind_confirm_popup').fadeOut();
    });
    $('.close_reward').on('click', function() {
      $('.reward_popup').fadeOut();
    });
    $('.jump_btn').on('click', function() {
      const href = $(this).data('href');
      const eventName = $(this).data('event');
      if (eventName) {
        requestInterface.countNum(eventName);
      }
      if (href) {
        window.location.href = href;
      }
    });

    var codeClipboard = new Clipboard(document.querySelector(".copy_link_btn"));
    codeClipboard.on("success", function (e) {
      layer.msg("已復製至剪貼板，快分享給好友吧~");
      requestInterface.countNum('復製鏈接');
      return;
    });
    codeClipboard.on("error", function (e) {
      console.error("Action:", e.action);
      console.error("Trigger:", e.trigger);
    });
  },
  indexSwiper: function() {
    let mySwiper = new Swiper('.swiper-container', {
      pagination: '.swiper-pagination',
      direction: 'vertical',
      slidesPerView: 'auto',
      paginationClickable: true,
      spaceBetween: 0,
      mousewheel: true,
      resistanceRatio: 0,
      initialSlide: initialSlide,
      touchMoveStopPropagation: false,
      touchStartForcePreventDefault: true,
      on: {
        init: function() {}
      }
    });

    const changeActivePage = (activeIndex) => {
      let idx = 1;
      if (activeIndex === 4) {
        idx = 5;
      } else if (activeIndex === 10) {
        idx = 1;
      } else {
        idx = activeIndex - 4;
      }
      $('.content-04 .page').attr('class', `page active_${idx}`);
    };

    let activeSwiper = new Swiper('.swiper-container2', {
      loop: true,
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      simulateTouch : false,
      coverflow: {
          rotate: 0,// 旋转的角度
          stretch: 15,// 拉伸   图片间左右的间距和密集度
          depth:30,// 深度   切换图片间上下的间距和密集度
          modifier: 10,// 修正值 该值越大前面的效果越明显
          slideShadows : false// 页面阴影效果
      },
      onSlideChangeStart: function(swiper) {
        changeActivePage(swiper.activeIndex);
      },
      onTouchEnd: function (swiper) {
        changeActivePage(swiper.activeIndex);
      },
    });

    $('.content-04 .prev_btn').on('click', function() {
      activeSwiper.slidePrev();
    });
    $('.content-04 .next_btn').on('click', function() {
      activeSwiper.slideNext();
    });
    $('.content-04 .page span').on('click', function() {
      const idx = $(this).data('idx');
      activeSwiper.slideTo(idx + 4);
    });

    let roleSwiper = new Swiper('.role_list_swiper', {
      spaceBetween: 0,
      initialSlide: 4,
      slidesPerView: 5,
      centeredSlides: !0,
      slideToClickedSlide: true,
      onlyExternal: true,
      loop: true,
      onSlideChangeStart: function(swiper) {
        const idx = $(swiper.clickedSlide).data('idx');
        $('.level_box .role_star').fadeOut().siblings(`.role_star_${idx}`).fadeIn();
        $(`.threesixty-${idx}`).fadeIn().siblings('.threesixty').fadeOut();
        $(`.role_intro_${idx}`).fadeIn().siblings('.role_intro_item').fadeOut();
        $('.cg_btn').data('idx', idx);
      }
    });

    obj.ThreeSixtyJs();
  },
  ThreeSixtyJs: function() {

    function productInfo() {
      const fontUnit = Number($('html').css('font-size').replace('px', ''));
      const width = 16.2 * fontUnit;
      const height = 28.8 * fontUnit;
      $('.threesixty .threesixty_images').html('');
      var product1 = $('.threesixty-1').ThreeSixty({
        totalFrames: 81,
        endFrame: 12,
        currentFrame: 5,    
        imgList: '.threesixty_images-1',
        progress: '.spinner-1',
        imagePath: 'card-pool/1/',
        filePrefix: '',
        ext: '.webp',
        width: width,
        height: height,
        navigation: false,
        disableSpin: false
      });
      var product2 = $('.threesixty-2').ThreeSixty({
        totalFrames: 81,
        endFrame: 1,
        currentFrame: 5,    
        imgList: '.threesixty_images-2',
        progress: '.spinner-2',
        imagePath: 'card-pool/4/',
        filePrefix: '',
        ext: '.webp',
        width: width,
        height: height,
        navigation: false,
        disableSpin: false
      });
      var product3 = $('.threesixty-3').ThreeSixty({
        totalFrames: 80,
        endFrame: 1,
        currentFrame: 5,    
        imgList: '.threesixty_images-3',
        progress: '.spinner-3',
        imagePath: 'card-pool/3/',
        filePrefix: '',
        ext: '.webp',
        width: width,
        height: height,
        navigation: false,
        disableSpin: false
      });
      var product4 = $('.threesixty-4').ThreeSixty({
        totalFrames: 81,
        endFrame: 1,
        currentFrame: 5,    
        imgList: '.threesixty_images-4',
        progress: '.spinner-4',
        imagePath: 'card-pool/2/',
        filePrefix: '',
        ext: '.webp',
        width: width,
        height: height,
        navigation: false,
        disableSpin: false
      });
      var product5 = $('.threesixty-5').ThreeSixty({
        totalFrames: 80,
        endFrame: 1,
        currentFrame: 5,    
        imgList: '.threesixty_images-5',
        progress: '.spinner-5',
        imagePath: 'card-pool/5/',
        filePrefix: '',
        ext: '.webp',
        width: width,
        height: height,
        navigation: false,
        disableSpin: false
      });
      
      $('.threesixty-5').fadeIn();
      $('.role_intro_5').fadeIn();
      $('.level_box .role_star_5').fadeIn();
    }
    productInfo();        
  },
  // 初始化用户信息
  onInit: function() {
    requestInterface.init({
      access_token: localStorage.getItem('access_token') 
    }, function(response) {
      const { data } = response;
      if (response.code == 200) {
        const { user_info, activity } = data;
        activity.key = activeKey;
        activity.game_id = 60;
        activity.token = user_info.account;
        config.roleName = activity.role_name;
        config.moveRoleName = activity.notice.account;
        config.account = user_info.account;
        obj.updateHeader();
        // 更新我的奖池
        const rewardList = activity.reward_list;
        let rewardHtml = ''; 
        awardNum = 0;
        gameNum = activity.times;
        isBindRole = activity.is_bind == 1;
        if (isBindRole) {
          const {key, role_id, role_name, server_id, server_name, platform,game_id, token } = activity;
          bindParams = { key, role_id, role_name, server_id, server_name, platform,game_id, token };
          $('.reward_popup .reward_box p span').text(`${role_name}(${server_name})`);
        } else {
          bindParams = {};
        }
        if (activity.notice) {
          const { account, title } = activity.notice;
          $('.winner_box .role_name').text(config.moveRoleName);
          $('.winner_box .award_name').text(title);
          $('.winner_box').show();
        } else {
          $('.winner_box').hide();
        }
        rewardList.forEach((item) => {
          if (item.is_send === 0) {
            awardNum ++;
          }
          rewardHtml += `<li class="${item.is_send === 1 ? 'reward' : ''}"><p><span>${item.remark}</span></p></li>`;
        });

        if (rewardList.length > 4) {
          $('.my_prize_popup .more_icon').show();
        } else {
          $('.my_prize_popup .more_icon').hide();
        }

        $('.my_prize_popup .list ul').html(rewardHtml);
        $('.content-02 .operation .number span').text(activity.times);
        $('.copy_link_btn').attr('data-clipboard-text', `${shareText}  https://sakura.snell.com.tw/m-card-pool/enter1701393170?helper_id=${activity.user_id}`);
      } else {
        // 未登录弹窗
        obj.openLoginPopup();
      }
    });
  },
  // 打开登陆弹窗
  openLoginPopup: function() {
    $('.inp-account').val('');
    $('.inp-password').val('');
    $('.phone-inp').val('');
    $('input[name=sms_code]').val('');
    $('.inp-role-name').val('');
    $('.inp-role-id').val('');
    clearTimeout(timer);
    wait = 60;
    setTimeout(() => {
        $('.obtain-verification label span a').remove();
        $('.obtain-verification label span').html("<a>发送</a>");
    }, 100);
    $('.register-popup').fadeIn();
  },
  // 登陆弹窗相关事件绑定
  loginEventBind: function() {
    // 切换登陆方式
    $('.register-box .title').on('click', 'div', function(event) {
      $(this).addClass('active').siblings().removeClass('active');
      for (var i = 0; i <= 2; i++) {
        $('.form-main').removeClass('move-'+i+'')
      };
      $('.form-main').addClass('move-'+$(this).attr('data')+'')
    });
    // 登陆弹窗关闭按钮
    $('.register-popup .close-bg').on('click', function() {
      $('.register-popup').fadeOut();
    });
    // 光子服/正式服 切换
    $('.tab-server').on('click', 'div', function(event) {
      $(this).addClass('active').siblings().removeClass('active')
        .parent('.tab-server').siblings('.option-main')
        .children('.option-box').eq($(this).index())
        .addClass('show').siblings().removeClass('show');

      $('.gzf select').val('0')
      $('.gzf input[name=gzf_role_name]').val('')
      $('.zsf-os').val('')
      $('.zsf-server').val('')
      $('.zsf input[name=zsf_role_name]').val('');

      bindParams = {
        game_id: $(this).parent().find('.active').attr('data-game-id'),
        role_id: "",
        role_name: "",
        server_id: "",
        server_name: "",
        type: ""
      };
    });

    // 账户登陆
    $('.login-btn').click(function(event) {

      const account = $('.inp-account').val();
      const password = $('.inp-password').val();
      if (account == '') {
        console.log(666)
        layer.msg("請輸入您的賬號", { time: 2000 });
        return false;
      }
      // if (password == '') {
      //     layer.msg("请输入您的密码", { time: 2000 });
      //     return false;
      // }
      requestInterface.accountLogin(
        {role_id: account, game_id:60}, function(response) {
          localStorage.setItem('access_token', response.data.access_token);
          $('.popup').fadeOut();
          obj.onInit();
        });
    });
    // 验证码登陆
    $('.sms-login').click(function() {
      const account = $('.phone-inp').val();
      const code = $('input[name=sms_code]').val();

      if (account == '') {
        layer.msg("请输入正确的手机号", { time: 2000 });
        return false;
      }
      if (!code) {
        layer.msg("请输入您的验证码", { time: 2000 });
        return false;
      }

      requestInterface.smsLogin(
        {account, sms_code: code, is_remember: 1}, function(response) {
          localStorage.setItem('access_token', response.data.access_token);
          $('.popup').fadeOut();
          obj.onInit();
        });
    });

    // 验证码发送
    $('.obtain-verification').on('click', 'a', function(event) {
      const phone = $('.phone-inp');
      if (!phone.val()) {
          layer.msg("请输入手机号", { time: 2000 });
          phone.focus();
          return false;
      }
      requestInterface.sendSms(phone.val());
    });

    // 绑定角色
    $('.confirm-btn').click(function(event) {
      console.log(bindParams);
      if (bindParams.role_id == undefined) {
        layer.msg("請先選擇信息");
        return false;
      }
      // TODO: 二次确认弹窗
      $('.bind_confirm_popup .bind_confirm_box p span').text(`${bindParams.role_name}(${bindParams.server_name})`);
      $('.server-popup').fadeOut();
      $('.bind_confirm_popup').fadeIn();
    });
    $('.cancell-btn').on('click', function() {
      $('.server-popup').fadeOut();
    });

    $('.channel-cancell-btn').click(function(event) {
      obj.onLogout();
    });

    // 头部点击
    $('.header .login_btn').on('click', function() {
      obj.openLoginPopup();
      requestInterface.countNum('登陆按钮');
    });
    $('.header .logout_btn').on('click', function() {
      $('.logout-popup').fadeIn();
      requestInterface.countNum('注销按钮');
    });
    $('.logout-popup .close-bg').on('click', function() {
      $('.logout-popup').fadeOut();
    });
  },
  serverInfo: function(account) {
    // 初始化打开状态
    $('.tab-server').show();
    $('.tab-server').find('.active').removeClass('active');
    $('.tab-server').find('div:first').addClass('active');
    $('.gzf').addClass('show');
    $('.zsf').removeClass('show');
    $('input[name=gzf_role_name]').val('');
    $('input[name=zsf_role_name]').val('');

    // 初始化参数状态
    bindParams = {};
    requestInterface.getRoleList({},function(json) {
      var xff = json.data[60]
      if (!xff) {
        layer.msg("查無您的角色信息")
        return false;
      }  else {
        console.log(123345)
        $('.tab-server').show();
      }

      if (xff) {
        $('.gzf select').html('<option value="0">請選擇區組</option>');
        var list = xff.android;
        for (var key in list) {
          var value = list[key];
          const jsonExtra = JSON.stringify(value['extra'])
          $('.gzf select').append('<option data-role_id="' + value['role_id'] + '" data-role-name="' + value['role_name'] + '" data-serverId="' + value['server_id']  + '" data-platform="' + value['platform'] + '" data-extra=' + jsonExtra + ' data-server_name="' + value['server_name'] + '">' + value['server_name'] +'</option>')
        }

        $('.gzf select').off('change').on('change', function() {
          var option = $(this).find('option:selected');
          console.log('option', option.val());
          if (option.val() && option.val() != '0') {
            // 改值
            $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
            bindParams = {
              game_id: 60,
              role_id: option.attr('data-role_id'),
              role_name: option.attr('data-role-name'),
              server_id: option.attr('data-serverId'),
              server_name: option.attr('data-server_name'),
              type: "android",
              platform: option.attr('data-platform'),
              extra: option.attr('data-extra')
            }
          } else {
            // 清空
            $('input[name=gzf_role_name]').val('');
            bindParams = {}
          }
        });
      } else {
        $('.gzf').removeClass('show');
      }

   

      $('.inp-account').val(''); // 账号密码清空
      $('.inp-password').val(''); // 账号密码清空
      $('.register-popup').fadeOut(); // 关闭登陆页面
      $('.server-popup').fadeIn(); // 开启服务器
    });
  },
  updateHeader: function() {
    if (config.account) {
      $('.header .info .intro').text(config.roleName);
      $('.header .login_btn').hide();
      $('.header .logout_btn').show();
    } else {
      $('.header .info .intro').text('請先登入');
      $('.header .login_btn').show();
      $('.header .logout_btn').hide();
      
    }
  },
  onLogout: function() {
    requestInterface.logout(function(json) {
      if (json.code == 200) {
        $('#account').html('請先登入');
        $('#server_name').html('');
        $('#role_name').html('');

        config.role_id = '';
        config.account = '';
        awardNum = 0;
        gameNum = 0;
        isBindRole = false;
        bindParams = {};

        obj.updateHeader();
        $('.content-02 .operation .number span').text(0);
        $('.my_prize_popup .list ul').html('');
        localStorage.setItem('access_token', '');
      }
    });
    $('.popup').fadeOut();
  },
}

requestInterface = {
  accountLogin: function(data, callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/sea/login",
      type: "POST",
      xhrFields: { withCredentials: true },
      data,
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        callback && callback(json);
      },
      complete: function() {
        layer.close(index)
      }
    });
  },
  smsLogin: function(data, callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + '/snail/login/sms',
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
      }
  })
  },
  sendSms: function(phone) {
    const index = layer.load(1);
    $.ajax({
      url: api + '/snail/login/sms/send',
      type: "POST",
      data: { mobile: phone, channel: "login" },
      xhrFields: { withCredentials: true },
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        } else {
          // 倒计时
          time();
        }
      },
      complete: function() {
        layer.close(index);
      }
    });
  },
  logout: function(callback) {
    const index = layer.load(1);
    $.ajax({
      url: api + "/sea/cherry/taiwan/draw/logout",
      type: "POST",
      data: { key: activeKey },
      xhrFields: { withCredentials: true },
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
        } else {
          layer.msg('註銷成功');
        }
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
      }
    });
  },
  getRoleList: function(data, callback) {
    data.key = activeKey;
    data.access_token = localStorage.getItem('access_token') || '';
    const index = layer.load(1);
    $.ajax({
      url: `${api}/sea/cherry/taiwan/draw/role?access_token=${data.access_token}&key=${data.key}`,
      type: "GET",
      xhrFields: { withCredentials: true },
      success: function(json) {
    
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        console.log(json);
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
      }
    });
  },

  // 业务接口
  init: function(data, callback) {
    data.key = activeKey;
    data.access_token = localStorage.getItem('access_token') || '';
    const index = layer.load(1);
    $.ajax({
      url: `${api }/sea/cherry/taiwan/draw/init?access_token=${data.access_token}&key=7974977f085eb505dbf63755c2328a13`,
      type: "GET",
      // data,
      xhrFields: { withCredentials: true },
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
        } else {
          // localStorage.setItem('access_token', json.data.activity.access_token);
        }
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
      }
    });
  },
  share: function(data = {}, callback) {
    data.key = activeKey;
    data.access_token = localStorage.getItem('access_token') || '';
    const index = layer.load(1);
    $.ajax({
      url: api + "/sea/cherry/taiwan/draw/share",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function(json) {
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
      }
    });
  },
  lottery: function(data = {}, callback) {
    data.key = activeKey;
    data.access_token = localStorage.getItem('access_token') || '';
    const index = layer.load(1);
    $.ajax({
      url: api + "/sea/cherry/taiwan/draw/lottery",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        // {
        //   "code": 200,
        //   "message": "ok",
        //   "data": {
        //     "prize_id": 1,
        //     "is_good": 0
        //   }
        // }
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
        $('.prevent-wrap').hide();
      }
    });
  },
  reward: function(data = {}, callback) {
    data.key = activeKey;
    data.access_token = localStorage.getItem('access_token') || '';
    const index = layer.load(1);
    $.ajax({
      url: api + "/sea/cherry/taiwan/draw/reward",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function(json) {
        if (json.code != 200) {
          layer.msg(json.message);
          return false;
        }
        callback && callback(json);
      },
      complete: function() {
        layer.close(index);
        $('.prevent-wrap').hide();
      }
    });
  },
  countNum: function(data) {
    setTimeout(() => {
      try {
        __bl.sum(data);
      } catch (e) {
        console.log(e)
      }
    }, 500);
  }
};

// 验证码倒计时
function time() {
  if (wait == 0) {
    $('.obtain-verification label span a').remove();
    $('.obtain-verification label span').html("<a>发送</a>");
    wait = 60;
  } else {
    $('.obtain-verification label span a').remove();
    $('.obtain-verification label span').html("<b>" + wait + "秒</b>");
    wait--;
    timer = setTimeout(function() {
      time()
    }, 1000);
  }
}

function analysisParams(url) {
  const params = {};
  const paramsString = url.split('?')[1];
  if (!paramsString) {
    return params;
  }
  const str = paramsString.split('&');
  for (let idx = 0; idx < str.length; idx++) {
    const values = str[idx].split('=');
    params[values[0]] = values[1];
  }
  return params;
};